import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'kmp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'kms';

  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
    this.iconRegistry.addSvgIcon(
      'portaverse-white',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/portaverse-white.svg')
    );
    this.iconRegistry.addSvgIcon(
      'camera-add',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/camera-add.svg')
    );
    this.iconRegistry.addSvgIcon(
      'portaverse',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/portaverse.svg')
    );
    this.iconRegistry.addSvgIcon(
      'kmap',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/kmap.svg')
    );
    this.iconRegistry.addSvgIcon(
      'home',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/home.svg')
    );
    this.iconRegistry.addSvgIcon(
      'avatar',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/avatar.svg')
    );
    this.iconRegistry.addSvgIcon(
      'analytics',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/analytics.svg')
    );
    this.iconRegistry.addSvgIcon(
      'ask',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ask.svg')
    );
    this.iconRegistry.addSvgIcon(
      'community',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/community.svg')
    );
    this.iconRegistry.addSvgIcon(
      'employee',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/employee.svg')
    );
    this.iconRegistry.addSvgIcon(
      'quarter',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/quarter.svg')
    );
    this.iconRegistry.addSvgIcon(
      'repository',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/repository.svg')
    );
    this.iconRegistry.addSvgIcon(
      'profile',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/profile.svg')
    );
    this.iconRegistry.addSvgIcon(
      'communities',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/communities.svg')
    );
    this.iconRegistry.addSvgIcon(
      'top',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/top.svg')
    );
    this.iconRegistry.addSvgIcon(
      'building',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/building.svg')
    );
    this.iconRegistry.addSvgIcon(
      'briefcase',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/briefcase.svg')
    );
    this.iconRegistry.addSvgIcon(
      'target-edit',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/target-edit.svg')
    );
    this.iconRegistry.addSvgIcon(
      'facebook',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/facebook.svg')
    );
    this.iconRegistry.addSvgIcon(
      'linkedin',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/linkedin.svg')
    );
    this.iconRegistry.addSvgIcon(
      'twitter',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/twitter.svg')
    );
  }
}
